import React, { useCallback, useContext, useState } from "react";
import styles from "./index.module.scss";
import CoursewareItem from "./components/CoursewareItem";
import CoursewareModal from "./components/CoursewareModal";
import useModalHandler from "Utils/useModalHandler";
import { Icon, Spin } from "antd";
import { CourseContext } from "../Store";
import useRequest from "Utils/useRequest";
import { CoursewareListItem, getCoursewareList } from "API/courseware";
import CustomEmpty from "../../../components/CustomEmpty";

export default function Courseware() {
    const modal = useModalHandler();

    const { course } = useContext(CourseContext);
    const { weekTimeId, courseNo, courseSeq } = course;

    const [current, setCurrent] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getCoursewareList({ weekTimeId, courseNo, courseSeq }),
        {},
        [weekTimeId, courseNo, courseSeq]
    );

    const onViewCourseware = useCallback(
        (item: CoursewareListItem) => {
            modal.open();
            setCurrent(item.id);
        },
        [modal]
    );

    return (
        <div className={styles.root}>
            <div className={styles.count}>
                课件（{data?.length || 0}）
                <a
                    style={{ paddingLeft: 10 }}
                    href="https://share.plvideo.cn/front/video/view?vid=5c0ad4c56c8d3791311cca1a47fef146_5"
                    target="_blank"
                    rel="noopener noreferrer">
                    <Icon type="play-square" style={{ marginRight: 5 }} />
                    点击查看使用说明视频
                </a>
            </div>

            <Spin spinning={loading}>
                <div className={styles.list}>
                    {data?.map(item => (
                        <CoursewareItem
                            key={item.id}
                            data={item}
                            onClick={() => onViewCourseware(item)}
                        />
                    ))}
                </div>
            </Spin>

            {data?.length === 0 && (
                <CustomEmpty style={{ padding: "100px 0" }} />
            )}

            <CoursewareModal
                visible={modal.visible}
                onCancel={modal.close}
                onSelect={setCurrent}
                onChange={refresh}
                current={current}
                list={data || []}
            />
        </div>
    );
}
